import React from "react";
import { Text, TextProps } from "react-native";

export const AHTextEmphazis = ({
  text,
  empahzize,
  EmpazisComponent,
}: {
  empahzize: string;
  text: string;
  EmpazisComponent: React.FC<TextProps>;
}) => {
  const startIndex = text.toLowerCase().indexOf(empahzize.toLowerCase());

  const strBefore = startIndex >= 0 ? text.slice(0, startIndex) : text;
  const middleString =
    startIndex >= 0
      ? text.slice(startIndex, startIndex + empahzize.length)
      : "";
  const strAfter =
    startIndex >= 0 ? text.slice(startIndex + empahzize.length) : "";

  return (
    <Text>
      {strBefore}
      <EmpazisComponent>{middleString}</EmpazisComponent>
      {strAfter}
    </Text>
  );
};
